import { combineReducers } from 'redux';
import connectionStatusReducer from './reducers/connectionStatusUpdater';
import getPricingInfoReducer from './reducers/getPricingInfoReducer';
import { SOLACE_PRICEING_DATA } from './actions/getPricingInfoActions';
import currentSectionUpdateReducer from './reducers/currentSectionUpdater';
import { storeSolaceCredentialsReducer } from './reducers/storeSolaceCredentialsReducer';
import { STORE_SOLACE_CREDENTIALS } from './actions/storeSolaceCredentialsActions';
import TOASTER_DATA from '../components/shared/toaster/constants'
import { toasterReducer } from './reducers/toasterReducer';
import { STORE_BROKER_FIELD_DETAILS } from './actions/storeBrokerFieldDetailsActions';
import { storeBrokerFieldDetailsReducer } from './reducers/storeBrokerFieldDetailsReducer';
import { STORE_PUBLISH_FIELD_DETAILS } from './actions/storePublishFieldDetailsActions';
import { storePublishFieldDetailsReducer } from './reducers/storePublishFieldDetailsReducer';
import { getSubscribePriceScreenDataReducer } from './reducers/getSubscribePriceScreenReducer';
import { GET_SUBSCRIBE_PRICE_SCREEN_DATA } from './actions/getSubscribePriceScreenActions';
import { STORE_PUBLISH_FIELD_DETAILS_2 } from './actions/storePublishFieldDetails2Actions';
import { storePublishFieldDetails2Reducer } from './reducers/storePublishFieldDetails2Reducer';

const rootReducer = combineReducers({
  connectionStatus: connectionStatusReducer,
  [SOLACE_PRICEING_DATA] : getPricingInfoReducer,
  currentSection: currentSectionUpdateReducer,
  [STORE_SOLACE_CREDENTIALS] : storeSolaceCredentialsReducer,
  [TOASTER_DATA] : toasterReducer,
  [STORE_BROKER_FIELD_DETAILS] : storeBrokerFieldDetailsReducer,
  [STORE_PUBLISH_FIELD_DETAILS] : storePublishFieldDetailsReducer,
  [GET_SUBSCRIBE_PRICE_SCREEN_DATA] : getSubscribePriceScreenDataReducer,
  [STORE_PUBLISH_FIELD_DETAILS_2] : storePublishFieldDetails2Reducer
});

export default rootReducer;
